import { FormattedMessage } from 'react-intl'
import TutorialConnectorButton from '@components/TutorialConnectorButton/TutorialConnectorButton'

import emptyImage from '@static/images/resource-list/no-items.jpg'
import './ConnectorsEmptyList.css'

export default function ConnectorsEmptyList() {
  return (
    <>
      <div className="connectors-empty-list">
        <div className="content">
          <img src={emptyImage} alt="" aria-hidden="true" />
          <h2>
            <FormattedMessage id="connectors-empty-list.title" />
          </h2>
          <p>
            <FormattedMessage id="connectors-empty-list.text" />
          </p>
        </div>
        <TutorialConnectorButton />
      </div>
    </>
  )
}
